import React from "react";
import { bool, node, string } from "prop-types";

import { useDrawerContext } from "../../utilities/drawerHelpers";
import { shouldShowMobileDesign } from "../../utilities/shouldShowMobileDesign";
import * as S from "./styled";

const ContactBox = ({ children, className, hasPadding, header, isModal }) => {
  const hasDrawerForm = useDrawerContext();
  const isMobileDesign = shouldShowMobileDesign({
    isModal
  });
  return (
    <S.ContactBox
      $hasDrawerForm={hasDrawerForm}
      className={className}
      header={header}
      isMobile={isMobileDesign && !hasDrawerForm}
      isModal={isModal}
      noPadding={!hasPadding}
    >
      {children}
    </S.ContactBox>
  );
};

ContactBox.propTypes = {
  children: node.isRequired,
  className: string,
  hasPadding: bool,
  header: node,
  isModal: bool
};

ContactBox.defaultProps = {
  className: "",
  hasPadding: false,
  header: null,
  isModal: false
};

export default ContactBox;
